import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IGoalTrackerForCardReward,
  IGoalTrackerForCardRewardResponse,
  IGoalTrackerProgressCard,
} from '../../components/GoalTracker/GoalTrackerTypes';

interface IGoalTrackerRequests {
  goalProgress: IGoalTrackerProgressCard | null;
  goalTrackers: IGoalTrackerForCardReward[];
  unreadGoalTrackersCount: number;
  isFetching: boolean;
  errorMessage: string;
}

const initialState: IGoalTrackerRequests = {
  goalTrackers: [],
  goalProgress: null,
  unreadGoalTrackersCount: 0,
  isFetching: false,
  errorMessage: '',
};

const goalTrackerSlice = createSlice({
  name: 'goalTracker',
  initialState,
  reducers: {
    getCurrentGoalTrackersForCardReward(state, action: PayloadAction<string | undefined>) {},
    fetchUnreadGoalTrackersCount() {},
    markTrackerAsRead(state, action: PayloadAction<number>) {},
    confirmReward(state, action: PayloadAction<number>) {},
    setGoalProgress(state, action: PayloadAction<IGoalTrackerProgressCard | null>) {
      state.goalProgress = action.payload;
    },
    setIsFetching(state, action: PayloadAction<boolean>) {
      state.isFetching = action.payload;
    },
    setErrorMessage(state, action: PayloadAction<string>) {
      state.errorMessage = action.payload;
    },
    setGoalTrackers(state, action: PayloadAction<IGoalTrackerForCardRewardResponse>) {
      state.goalTrackers = action.payload.data;
    },
    setUnreadGoalTrackersCount(state, action: PayloadAction<number>) {
      state.unreadGoalTrackersCount = action.payload;
    },
    decrementUnreadGoalTrackersCount(state) {
      state.unreadGoalTrackersCount = Math.max(0, state.unreadGoalTrackersCount - 1);
    },
  },
});

export const goalTrackerActions = goalTrackerSlice.actions;
export const goalTrackerReducer = goalTrackerSlice.reducer;
